import { render, staticRenderFns } from "./Competencias_editar.vue?vue&type=template&id=b9ceac48"
import script from "./Competencias_editar.vue?vue&type=script&lang=js"
export * from "./Competencias_editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports